<template>
    <div class="web-component-wrap">
        <template v-if="blockName === 'wpvcb/home-banner'">
            <home-banner :mobile-bg-image="blockData.filtered_content.enable_mobile_bg ?
                blockData.filtered_content.mobile_bg_image : ''"
                :logo-image="blockData.filtered_content.logo_image"
                :logo-title="blockData.filtered_content.logo_title"
                :bg-image="blockData.filtered_content.bg_image"
                :banner-style="blockData.filtered_content.banner_style"
                :heading-tag="blockData.filtered_content.heading_tag"
                :enable-font-color="blockData.filtered_content.custom_font_color || 'white'"
                :heading="blockData.filtered_content.heading"
                :disable-show-more-mob="blockData.filtered_content.disable_showmore_mobile"
                :mobile-text="blockData.filtered_content.mobile_text"
                :no-mob-lines="blockData.filtered_content.no_of_lines_mobile"
                :banner-text="blockData.filtered_content.text"
                :no-banner-lines="blockData.filtered_content.no_of_lines"
                :banner-guide-cards="JSON.stringify(blockData.filtered_content.cards)"
                :recommended-title-tag="blockData.filtered_content.recommended_title_tag"
                :recommended-by="blockData.filtered_content.recommended_by"
                :toplist-data="getHomeBannerToplist(blockData.filtered_content.toplist_data)"
                :toplist-bg-color="blockData.filtered_content.toplist_bg_color"
                :toplist-bns-color="blockData.filtered_content.toplist_bns_color || 'white' "
                :toplist-bns-hover-color="blockData.filtered_content.toplist_bns_hover_color"
                :spa-router="$root.enable_piwik_reload"
                @emitSpaRoute="routeToPage"/>
        </template>
        <template v-else-if="blockName === 'wpvcb/home-card-testimonials'">
            <home-card-testimonials :card-style="blockData.filtered_content.style"
                :column-number="blockData.filtered_content.card_testimonials_columns"
                :card-testimonial-data="JSON.stringify(blockData.filtered_content.card_testimonials)"
                :card-data="JSON.stringify(blockData.filtered_content.cards)" />
        </template>
        <template v-else-if="blockName === 'wpvcb/blue-progressive-block'">
            <blue-progressive-block :bg_pattern="blockData.attrs.bg_pattern"
                :bg_color="blockData.filtered_content.bg_color || '#0084ff'"
                :title_tag="blockData.attrs.title_tag"
                :title="blockData.filtered_content.title"
                :content="blockData.filtered_content.content"
                :logo="blockData.filtered_content.logo"
                :style="blockData.filtered_content.style"/>
        </template>
        <template v-else-if="blockName === 'wpvcb/content-icon-block'">
            <content-icon-block :template-check="'false'"
                :button-check="`${Object.keys(blockData.filtered_content).length > 0
                    ? blockData.filtered_content &&
                        blockData.filtered_content.cta_partner &&
                        Object.keys(blockData.filtered_content.cta_partner).length > 0
                        ? true
                        : false
                    : false}`"
                :partner-info="blockData.filtered_content.cta_partner || ''"
                :icon="blockData.filtered_content.icon"
                :content="blockData.filtered_content.content" />
        </template>
        <template v-else-if="blockName === 'wpvcb/faq'">
            <faq-block :bg-pattern="blockData.filtered_content.faq_data.bg_pattern"
                :faq-name="blockData.filtered_content.faq_data.faq_name"
                :faq-style="blockData.filtered_content.faq_data.style"
                :faq-data="JSON.stringify(blockData.filtered_content.data)"/>
        </template>
        <template v-else-if="blockName === 'wpvcb/testimonials'">
            <user-testimonials :heading="blockData.filtered_content.heading"
                :sub-heading="blockData.filtered_content.sub_heading"
                :testimonial-data="JSON.stringify(blockData.filtered_content.testimonials)"/>
        </template>
        <template v-else-if="blockName === 'wpvcb/comparison-list-block'">
            <comparison-list :block-title="blockData.filtered_content.block_title"
                :comparison-style="blockData.filtered_content.style"
                :disabled-icon="blockData.filtered_content.disabled_icon"
                :comparison-right-data="JSON.stringify(blockData.filtered_content.right)"
                :comparison-left-data="JSON.stringify(blockData.filtered_content.left)"/>
        </template>
        <template v-else-if="blockName === 'wpvcb/published-date'">
            <published-date :publish-date="blockData.filtered_content.publish_date"
                :est-min-read="blockData.filtered_content.est_minutes_read" />
        </template>
        <template v-else-if="blockName === 'wpvcb/top-promotions'">
            <top-promotions :block-title="blockData.attrs.block_title"
                :enable-show-all-link="blockData.attrs.enable_show_all_link"
                :show-all-link="blockData.attrs.show_all_link"
                :display-offset="blockData.attrs.display_offset"
                :default-display="blockData.attrs.default_display"
                :promotion-data="JSON.stringify(blockData.filtered_content)"
                :block-use="'block'"
                :spa-router="$root.enable_piwik_reload"
                @emitSpaRoute="routeToPage"/>
        </template>
        <template v-else-if="blockName === 'wpvcb/geo-text'">
            <geo-text :text-tag="blockData.filtered_content.tag"
                :text-content="blockData.filtered_content.content" />
        </template>
        <template v-else-if="blockName === 'wpvcb/bullet-block'">
            <bullet-block :bullet-style="blockData.filtered_content.style"
                :bullet-content="blockData.filtered_content.content"
                :custom-bullet="blockData.filtered_content.custom_bullet" />
        </template>
        <template v-else-if="blockName === 'wpvcb/news-block'">
            <news-block :news-block-data="JSON.stringify(blockData.filtered_content)"
                :news-block-attrs="JSON.stringify(blockData.attrs)"
                :post-slug="$route.params.postSlug"
                :spa-router="$root.enable_piwik_reload"
                @emitSpaRoute="routeToPage"/>
        </template>
        <template v-else-if="blockName === 'wpvcb/stream-block'">
            <stream-block :stream-block-data="JSON.stringify(blockData.filtered_content)"
                        :stream-block-attrs="JSON.stringify(blockData.attrs)"
                        :post-slug="$route.params.postSlug"
                        :spa-router="$root.enable_piwik_reload"
                        @emitSpaRoute="routeToPage"/>
        </template>
        <template v-else-if="blockName === 'wpvcb/geo-image'">
            <geo-image :img-url="blockData.filtered_content.img_url"
                :img-alt="blockData.filtered_content.img_alt"
                :imgWidth="blockData.filtered_content.img_width"
                :imgHeight="blockData.filtered_content.img_height"/>
        </template>
        <template v-else-if="blockName === 'yoast/faq-block'">
            <yoast-faq :faq-data="yoastFaqData(blockData)"/>
        </template>
        <template v-else-if="blockName === 'wpvcb/author-block'">
            <author-block :block-style="blockData.filtered_content.style"
                :move-author-description-below="blockData.filtered_content.move_author_description_below"
                :post-date-read-time="blockData.filtered_content.post_date_read_time"
                :author-data="JSON.stringify(blockData.filtered_content.data)"/>
        </template>
        <template v-else-if="blockName === 'wpvcb/game-guide-categories'">
            <game-guide-categories :block-style="blockData.attrs.style"
                :enable-search="blockData.attrs.enable_search"
                :block-data="gameGuideData(blockData)"
                :spa-router="$root.enable_piwik_reload"
                @emitSpaRoute="routeToPage"/>
        </template>
        <template v-else-if="blockName === 'wpvcb/tab-switcher'">
            <tab-switcher :tab-switcher-data="JSON.stringify(blockData.filtered_content)"/>
        </template>
        <template v-else-if="blockName === 'wpvcb/best-payment-methods'">
            <best-payment-methods :bg-pattern="blockData.attrs.bg_pattern"
                :payment-style="blockData.attrs.style"
                :block-title="blockData.attrs.block_title"
                :block-title-tag="blockData.attrs.title_tag"
                :before-content="blockData.attrs.before_content"
                :remove-cas-count="blockData.attrs.remove_cascount"
                :enable-show-all-link="blockData.attrs.enable_show_all_link"
                :show-all-label="blockData.attrs.show_all_label"
                :show-all-link="blockData.attrs.show_all_link"
                :after-content="blockData.attrs.after_content"
                :payment-data="getBestPaymentData(blockData.filtered_content)"
                :spa-router="$root.enable_piwik_reload"
                @emitSpaRoute="routeToPage"/>
        </template>
        <template v-else-if="blockName === 'wpvcb/latest-casino'">
            <latest-casino :block-title="blockData.attrs.block_title"
                :latest-casino-data="JSON.stringify(blockData.filtered_content)"
                :pro-asset-size="assetSizes.pro_asset_sizes.medium"
                :bottom-link="blockData.attrs.enable_link"
                :bottom-link-url="blockData.attrs.link_url"
                :bottom-link-label="blockData.attrs.link_label"/>
        </template>
        <template v-else-if="blockName === 'wpvcb/link-block'">
            <link-block :link-block-title="blockData.filtered_content.title"
                :link-block-link="blockData.filtered_content.link" />
        </template>
        <template v-else-if="blockName === 'wpvcb/alternative-payment-options' && !!blockData.filtered_content.alternative_payment_methods">
            <alternative-payment-options :block-style="blockData.filtered_content.alternative_payment_methods.style"
                :block-title="blockData.filtered_content.alternative_payment_methods.title"
                :block-description="blockData.filtered_content.alternative_payment_methods.description"
                :payment-methods-data="getAlternativePaymentData(blockData.filtered_content.alternative_payment_methods.posts)"
                :payments-tag-order="JSON.stringify(blockData.filtered_content.alternative_payment_methods.payment_tags_order)"
                :remove-cas-count="blockData.filtered_content.alternative_payment_methods.remove_cascount"
                :spa-router="$root.enable_piwik_reload"
                :per-page="blockData.filtered_content.per_page"
                @emitSpaRoute="routeToPage"/>
        </template>
        <template v-else-if="blockName === 'wpvcb/team-block'">
            <team-block :title="blockData.filtered_content.title"
                :title-tag="blockData.filtered_content.title_tag"
                :description="blockData.filtered_content.description"
                :teams="JSON.stringify(blockData.filtered_content.teams_section.teams)"/>
        </template>
        <template v-else-if="blockName === 'wpvcb/custom-iframe'">
            <custom-iframe :iframe-data="JSON.stringify(blockData.filtered_content)"/>
        </template>
        <template v-else-if="blockName === 'wpvcb/whitebg-content-block'">
            <whitebg-content :block-title="blockData.filtered_content.title"
                :title-icon="blockData.filtered_content.title_icon"
                :content-icon="blockData.filtered_content.content_icon"
                :content="blockData.filtered_content.content"/>
        </template>
        <template v-else-if="blockName === 'wpvcb/top-games'">
            <top-games :block-style="blockData.attrs.style"
                :block-title="blockData.attrs.block_title"
                :block-data="getTopGamesData(blockData.filtered_content.data)"
                :disable-review="blockData.attrs.disable_review"
                :enable-filter="blockData.attrs.enable_filters"
                :show-all-games-link="blockData.attrs.enable_show_all_games_link ? blockData.attrs.show_all_games_link : ''"
                :enable-selected-game-cats="blockData.filtered_content.attrs.enable_selected_game_cats"
                :single-cat="blockData.filtered_content.attrs.single_cat"
                :single-cat-name="blockData.filtered_content.attrs.single_cat_name"
                :default-display="blockData.filtered_content.attrs.default_display"
                :load-offset="blockData.filtered_content.attrs.load_offset"
                :main-cas-loading="false"
                :spa-router="$root.enable_piwik_reload"
                @emitSpaRoute="routeToPage"/>
        </template>
        <template v-else-if="blockName === 'wpvcb/poker-hands'">
            <poker-hands :poker-hand-data="JSON.stringify(blockData.filtered_content.info)"/>
        </template>
        <template v-else-if="blockName === 'wpvcb/home-promote-banner'">
            <home-promote-banner :banner-data="JSON.stringify(blockData.filtered_content)"/>
        </template>
        <template v-else-if="blockName === 'wpvcb/youtube-film-strip'">
            <youtube-film-strip :youtube-data="JSON.stringify(blockData.filtered_content)"/>
        </template>
        <template v-else-if="blockName === 'wpvcb/other-software-provider'">
            <other-software-provider :block-title="blockData.attrs.block_title"
                :description="blockData.attrs.description"
                :software-provider-data="getOtherSoftwareProviderData(blockData.filtered_content.posts)"
                :spa-router="$root.enable_piwik_reload"
                @emitSpaRoute="routeToPage"/>
        </template>
        <template v-else-if="blockName === 'wpvcb/alternative-software-provider' && !!blockData.filtered_content.alternative_software_providers.posts">
            <alternative-software-provider :block-title="blockData.filtered_content.alternative_software_providers.block_title"
                :description="blockData.filtered_content.alternative_software_providers.description"
                :remove-cas-count="blockData.filtered_content.alternative_software_providers.remove_cascount"
                :software-provider-data="getAlternativeSoftwareProviderData(blockData.filtered_content.alternative_software_providers.posts)"
                :spa-router="$root.enable_piwik_reload"
                @emitSpaRoute="routeToPage"/>
        </template>
        <template v-else-if="blockName === 'wpvcb/related-articles'">
            <related-articles :block-title="blockData.attrs.block_title"
                :related-article-attrs ="blockData.attrs.enable_rich_pins"
                :related-article-attrs-title ="blockData.attrs.rich_pins_button_text"
                :block-data="JSON.stringify(blockData.filtered_content)"
                :spa-router="$root.enable_piwik_reload"
                @emitSpaRoute="routeToPage"/>
        </template>
        <template v-else-if="blockName === 'wpvcb/similar-casinos'">
            <similar-casinos :block-title="blockData.attrs.block_title"
                :block-data="getSimilarCasinoData(blockData.filtered_content)"
                :enable-payment-popup="blockData.attrs.enable_payment_popup"
                :spa-router="$root.enable_piwik_reload"
                @emitSpaRoute="routeToPage"/>
        </template>
        <template v-else-if="blockName === 'wpvcb/exclusive-casino'">
            <exclusive-casino :exclusive-casino-data="exclusiveCasinoData(blockData.filtered_content.casinos)"
                :first-card="JSON.stringify(blockData.filtered_content.first_card)"
                :bg-image="blockData.filtered_content.bg_image"
                :spa-router="$root.enable_piwik_reload"
                @emitSpaRoute="routeToPage"/>
        </template>
        <template v-else-if="blockName === 'wpvcb/article-banner'">
            <article-banner :content-width="blockData.filtered_content.content_width"
                :title="blockData.filtered_content.title"
                :url="blockData.filtered_content.url"
                :text-align="blockData.filtered_content.text_align"
                :enable-text-logo="blockData.filtered_content.enable_text_logo"
                :enable-text="blockData.filtered_content.enable_text"
                :text-logo="blockData.filtered_content.text_logo"
                :text-tag="blockData.filtered_content.text_tag"
                :text="blockData.filtered_content.text"/>
        </template>
         <template v-else-if="blockName === 'wpvcb/article-helpful-vote'">
            <article-helpful-vote :article-vote-data="JSON.stringify(blockData.filtered_content)"
                :disabled="userArticleVote.disabled"
                :helpful="userArticleVote.helpful"
                @getUserArticleVote="getUserArticleVote"/>
        </template>
        <template v-else-if="blockName === 'wpvcb/casino-toplist' && !!blockData.filtered_content">
            <casino-toplist :toplist-style="blockData.attrs.style"
                :recommend-section="JSON.stringify(recommendSection)"
                :block-data="JSON.stringify(blockData.filtered_content)"
                :block-attrs="JSON.stringify(blockData.attrs)"
                :page-value="pageValue"
                :assets-size="JSON.stringify(assetSizes)"
                :bluebar="JSON.stringify(bluebar)"
                :product-info-name="pageData ? pageData.product_information.name : null"
                :cas-loading="$root.casloading"
                :post-slug="$route.params.postSlug"
                :spa-router="$root.enable_piwik_reload"
                :block-index="blockIndex"
                @changeCasloading="changeCasloading"
                @emitSpaRoute="routeToPage"/>
        </template>
        <template v-else-if="blockName === 'wpvcb/main-casino-toplist'">
            <main-casino-toplist :block-data="JSON.stringify(blockData.filtered_content)"
                :block-attrs="JSON.stringify(blockData.attrs)"
                :page-value="'home'"
                :assets-size="JSON.stringify(assetSizes)"
                :cas-loading="$root.casloading"
                :spa-router="$root.enable_piwik_reload"
                @changeCasloading="changeCasloading"
                @emitSpaRoute="routeToPage"/>
        </template>
        <template v-else-if="blockName === 'wpvcb/howto-block'">
            <howto-block :title="blockData.filtered_content.title"
                :title-tag="blockData.filtered_content.title_tag"
                :intro="blockData.filtered_content.intro"
                :custom-font-color="blockData.filtered_content.enable_background ? blockData.filtered_content.custom_font_color : ''"
                :steps="JSON.stringify(blockData.filtered_content.steps)"
                :enable-bigger-image="blockData.filtered_content.enable_bigger_image"
                :hide-list-numbers="blockData.filtered_content.hide_list_numbers"
                :howto-id="`howto-${blockIndex}`"
                />
        </template>
        <template v-else-if="blockName === 'wpvcb/bonus-cards'">
            <bonus-cards :bonus-style="blockData.filtered_content.style"
                :bonus-info="JSON.stringify(blockData.filtered_content.info)"/>
        </template>
        <template v-else-if="blockName === 'wpvcb/pu-reference'">
            <pu-reference :title="blockData.filtered_content.title"
                :title-tag="blockData.filtered_content.title_tag"
                :block-style="blockData.filtered_content.style"
                :refs-item="JSON.stringify(blockData.filtered_content.ref_items)" />
        </template>
        <template v-else-if="blockName === 'wpvcb/intro-block'">
            <intro-block :intro-block-data="JSON.stringify(blockData.filtered_content)"
                :page-name="'home'"/>
        </template>
        <template v-else-if="blockName === 'wpvcb/newsletter'">
            <newsletter-block :bg-pattern="blockData.attrs.bg_pattern"
                :post-slug="$route.params.postSlug || ''"/>
        </template>
        <template v-else-if="blockName === 'wpvcb/top-games-articles'">
            <top-games-articles :top-article-title="blockData.attrs.block_title"
                :game-top-attrs-data="blockData.attrs.enable_rich_pins"
                :game-top-article-attrs-title-data="blockData.attrs.rich_pins_button_text"
                :top-article-data="JSON.stringify(blockData.filtered_content)"
                :block-style="blockData.attrs.style"
                :spa-router="$root.enable_piwik_reload"
                @emitSpaRoute="routeToPage"/>
        </template>
        <template v-else-if="blockName === 'wpvcb/feature-promotion'">
            <feature-promotion :partner-information="JSON.stringify(blockData.filtered_content.partner_information)"
                :meta-data="JSON.stringify(blockData.filtered_content.metadata)"
                :short-descrp="blockData.filtered_content.short_descrp"
                :spa-router="$root.enable_piwik_reload"
                @emitSpaRoute="routeToPage"/>
        </template>
        <template v-else-if="blockName === 'wpvcb/software-provider-block'">
            <software-provider-block :product-information="pageData ? JSON.stringify(pageData.product_information) : null"
                :software-provider="pageData ? JSON.stringify(pageData.software_provider) : null"
                :product-name="pageData.product_name"
                :product-licences="pageData ? JSON.stringify(pageData.product_licences) : null"
                :block-data="JSON.stringify(blockData.filtered_content)"
                :show-hide-obj="JSON.stringify(showHideObj)"
                id="review-casino-card-software"
            />
        </template>
        <template v-else-if="blockName === 'wpvcb/payment-option-block'">
            <payment-option-block :supported-payments="pageData ? JSON.stringify(pageData.supported_payments) : null"
                :minimum-deposit="pageData ? pageData.minimum_deposit : null"
                :minimum-withdraw="pageData ? JSON.stringify(pageData.minimum_withdraw) : null"
                :bonus-currency="pageData ? pageData.bonus_currency : null"
                :block-data="JSON.stringify(blockData.filtered_content)"
                :show-hide-obj="JSON.stringify(showHideObj)"
                id="review-casino-card-payment-method"
            />
        </template>
        <template v-else-if="blockName === 'wpvcb/languages-supports-block'">
            <languages-supports-block :supported-lang="supportedLang"
                :contact-number="pageData ? pageData.product_information.contact_number[0].contact_number : ''"
                :support-email="pageData ? pageData.product_information.support_email[0].email_address : ''"
                :contact-name="pageData ? pageData.product_information.contact_number[0].title : ''"
                :block-data="JSON.stringify(blockData.filtered_content)"/>
        </template>
        <template v-else-if="blockName === 'wpvcb/bonus-information-block'">
            <bonus-information-block :hide-bonus-label="hideBonusLabel"
                :assets-size="JSON.stringify(assetSizes)"
                :bonus-data="JSON.stringify(blockData.filtered_content)"
                :bonus-partner-data="pageData ? JSON.stringify(pageData.product_information) : null"
                :bonus-primary-colour="pageData ? pageData.primary_colour : null"
                />
        </template>
        <template v-else-if="blockName === 'wpvcb/recommended-casinos'">
            <recommended-casinos 
                :block-data="JSON.stringify(blockData.filtered_content)"
            />
        </template>
        <template v-else-if="blockName === 'core/shortcode'">
            <core-shortcode :block-data="blockData.filtered_content"/>
        </template>
        <template v-else-if="blockName === null">
            <null-block :block-data="blockData.filtered_content"/>
        </template>
        <template v-else-if="isCoreBlock(blockName) && blockName != null">
            <template v-if="blockName === 'simpletoc/toc'">
                <simple-toc :simple-toc-data="blockData.innerHTML"
                    :no-of-title-display="blockData.attrs.no_of_title_display"
                    :right-content="rightContent"/>
            </template>
            <template v-else>
                <core-content :block-data="coreBlockData(blockData)"
                    :block-attrs="coreBlockAttrs(blockData)"
                    :block-name="blockName"
                    :page-value="pageValue"
                    :scheme="scheme"
                    />
            </template>
        </template>
        <!-- <template v-else>
            {{blockName}}
        </template> -->
    </div>
</template>

<script>
import { HttpService } from "@/api/Pages.api";
import { getLang } from "@/misc/lang";

export default {
    name: 'CustomComponent',
    data: function ( ) {
        return {
            blockName: '',
            assetSizes: '',
            userArticleVote: {
                disabled: false,
                helpful: null
            },
            hideBonusLabel: false,
            rightContent: {},
            supportedLang: []
        }
    },
    props: [
        'blockData', 'recommendSection',
        'bluebar', 'pageData',
        'showHideObj','pageValue',
        'blockIndex', 'scheme'
    ],
    created: function() {
        this.blockName = this.blockData.blockName
        let asset_sizes = global.wpvue_script_data_params.data.site_data.asset_sizes
        this.assetSizes = Object.keys(asset_sizes).length > 0 ? asset_sizes : ""
        if(this.pageData) {
            this.getBonusShowHide(this.pageData)

            if (this.pageData.supported_language) {
                this.supportedLang = JSON.parse(
                    this.pageData.supported_language.language_name
                ).map((ele) => this.getLang(ele));
            } else {
                this.supportedLang = [];
            }
        }
    },
    mounted: function() {
        if(this.blockName === 'wpvcb/home-banner') {
            this.loadComponentScript('home-banner')
        } else if(this.blockName === 'wpvcb/blue-progressive-block') {
            this.loadComponentScript('blue-progressive-block')
        } else if(this.blockName === 'wpvcb/content-icon-block') {
            this.loadComponentScript('content-icon-block')
        } else if(this.blockName === 'wpvcb/home-card-testimonials') {
            this.loadComponentScript('home-card-testimonials')
        } else if(this.blockName === 'wpvcb/faq') {
            this.loadComponentScript('faq-block')
        } else if(this.blockName === 'wpvcb/bullet-block') {
            this.loadComponentScript('bullet-block')
        } else if(this.blockName === 'wpvcb/testimonials') {
            this.loadComponentScript('user-testimonials')
        } else if(this.blockName === 'wpvcb/comparison-list-block') {
            this.loadComponentScript('comparison-list')
        } else if(this.blockName === 'wpvcb/published-date') {
            this.loadComponentScript('published-date')
        } else if(this.blockName === 'wpvcb/geo-text') {
            this.loadComponentScript('geo-text')
        } else if(this.blockName === 'wpvcb/custom-iframe') {
            this.loadComponentScript('custom-iframe')
        } else if(this.blockName === 'wpvcb/related-articles') {
            this.loadComponentScript('related-articles')
        } else if(this.blockName === 'wpvcb/geo-image') {
            this.loadComponentScript('geo-image')
        } else if(this.blockName === 'yoast/faq-block') {
            this.loadComponentScript('yoast-faq')
        } else if(this.blockName === 'wpvcb/news-block') {
          this.loadComponentScript('news-block')
        } else if(this.blockName === 'wpvcb/stream-block') {
          this.loadComponentScript('stream-block')
        } else if(this.blockName === 'wpvcb/author-block') {
            this.loadComponentScript('author-block')
        } else if(this.blockName === 'wpvcb/top-games') {
            this.loadComponentScript('top-games')
        } else if(this.blockName === 'wpvcb/howto-block') {
            this.loadComponentScript('howto-block')
        } else if(this.blockName === 'wpvcb/link-block') {
            this.loadComponentScript('link-block')
        } else if(this.blockName === 'wpvcb/intro-block') {
            this.loadComponentScript('intro-block')
        } else if(this.blockName === 'wpvcb/bonus-cards') {
            this.loadComponentScript('bonus-cards')
        } else if(this.blockName === 'wpvcb/tab-switcher') {
            this.loadComponentScript('tab-switcher')
        } else if(this.blockName === 'wpvcb/other-software-provider') {
            this.loadComponentScript('other-software-provider')
        } else if(this.blockName === 'wpvcb/bonus-information-block') {
            this.loadComponentScript('bonus-information-block')
        } else if(this.blockName === 'wpvcb/alternative-software-provider'  && !!this.blockData.filtered_content.alternative_software_providers.posts) {
            this.loadComponentScript('alternative-software-provider')
        } else if(this.blockName === 'wpvcb/game-guide-categories') {
            this.loadComponentScript('game-guide-categories')
        } else if(this.blockName === 'wpvcb/best-payment-methods') {
            this.loadComponentScript('best-payment-methods')
        } else if(this.blockName === 'wpvcb/latest-casino') {
            this.loadComponentScript('latest-casino')
        } else if(this.blockName === 'wpvcb/top-promotions') {
            this.loadComponentScript('top-promotions')
        } else if(this.blockName === 'wpvcb/whitebg-content-block') {
            this.loadComponentScript('whitebg-content')
        } else if(this.blockName === 'wpvcb/team-block') {
            this.loadComponentScript('team-block')
        } else if(this.blockName === 'wpvcb/poker-hands') {
            this.loadComponentScript('poker-hands')
        } else if(this.blockName === 'wpvcb/newsletter') {
            this.loadComponentScript('newsletter-block')
        } else if(this.blockName === 'wpvcb/feature-promotion') {
            this.loadComponentScript('feature-promotion')
        } else if(this.blockName === 'wpvcb/home-promote-banner') {
            this.loadComponentScript('home-promote-banner')
        } else if(this.blockName === 'wpvcb/youtube-film-strip') {
            this.loadComponentScript('youtube-film-strip')
        } else if(this.blockName === 'wpvcb/exclusive-casino') {
            this.loadComponentScript('exclusive-casino')
        } else if(this.blockName === 'wpvcb/article-banner') {
            this.loadComponentScript('article-banner')
        } else if(this.blockName === 'wpvcb/pu-reference') {
            this.loadComponentScript('pu-reference')
        } else if(this.blockName === 'wpvcb/similar-casinos') {
            this.loadComponentScript('similar-casinos')
        } else if(this.blockName === 'wpvcb/casino-toplist' && !!this.blockData.filtered_content) {
            this.loadComponentScript('casino-toplist')
        } else if(this.blockName === 'wpvcb/main-casino-toplist') {
            this.loadComponentScript('main-casino-toplist')
        } else if(this.blockName === 'wpvcb/article-helpful-vote') {
            this.loadComponentScript('article-helpful-vote')
        } else if(this.blockName === 'wpvcb/top-games-articles') {
            this.loadComponentScript('top-games-articles')
        } else if(this.blockName === 'simpletoc/toc') {
            this.loadComponentScript('simple-toc')
        } else if(this.blockName === 'wpvcb/alternative-payment-options' && !!this.blockData.filtered_content.alternative_payment_methods) {
            this.loadComponentScript('alternative-payment-options')
        } else if(this.blockName === 'wpvcb/software-provider-block') {
            this.loadComponentScript('software-provider-block')
        } else if(this.blockName === 'wpvcb/payment-option-block') {
            this.loadComponentScript('payment-option-block')
        } else if(this.blockName === 'wpvcb/languages-supports-block') {
            this.loadComponentScript('languages-supports-block')
        } else if (this.blockName === 'wpvcb/recommended-casinos') {
            this.loadComponentScript('recommended-casinos')
        } else if(this.blockName === 'core/shortcode') {
            this.loadComponentScript('core-shortcode')
        } else if(this.blockName === null) {
            this.loadComponentScript('null-block')
        } else if(this.isCoreBlock(this.blockName) && this.blockName != null) {
            this.loadComponentScript('core-content')
        }
    },
    methods: {
        getLang,
        getBonusShowHide: function (partner) {
            let hideBonus = this.getCASToplistShowHideData(partner);
            if (hideBonus.hide_bonus === "1") {
                this.hideBonusLabel = true;
            } else if (hideBonus.hide_toplist === "1") {
                this.hideToplistLabel = true;
            }
        },
        changeCasloading: function(event) {
            this.$root.casloading = event.detail[0]
        },
        routeToPage: function(event) {
            this.$router.push(`${event.detail[0]}`)
        },
        getUserArticleVote: function(event) {
            let value = `${event.detail[0]}`
            if (this.$root.user_id != 0) {
              HttpService.userArticleVote(
                this.$root.wp_country && this.$root.wp_country != ""
                  ? this.$root.wp_country
                  : this.$cookies.get("wp-country"),
                this.$root.wp_state && this.$root.wp_state != ""
                  ? this.$root.wp_state
                  : this.$cookies.get("wp-state"),
                this.$route.params.postSlug,
                this.$root.user_id,
                value
              )
                .then((res) => {
                  const resData = res.data.data
                  if (resData.user_vote === false) {
                    this.userArticleVote.disabled = false
                  } else if (resData.user_vote === "up") {
                    this.userArticleVote.disabled = true
                    this.userArticleVote.helpful = true
                  } else if (resData.user_vote === "down") {
                    this.userArticleVote.disabled = true
                    this.userArticleVote.helpful = false
                  }
                })
                .catch((err) => console.log(err))
            } else {
              this.userArticleVote.disabled = true
            }
        },
        getAlternativePaymentData: function (paymentData) {
            return JSON.stringify(paymentData.map(ele => (
                    {
                        ID: ele.ID,
                        title: ele.title,
                        slug: ele.slug,
                        post_name: ele.post_name,
                        post_type: ele.post_type,
                        payment_category: ele.payment_category,
                        count: {
                            url: (ele.count.asset_category_name === this.assetSizes.pao_asset_sizes.medium) ? ele.count.url : '',
                            name: ele.count.name,
                            overview: ele.count.overview,
                            toplist_count: ele.count.toplist_count
                        }
                    }
                ))
            )
        },
        getOtherSoftwareProviderData: function (softwareData) {
            return JSON.stringify(softwareData.map(ele => (
                    {
                        soft_info: {
                            sw_name: ele.soft_info.sw_name,
                            swa_url: ele.soft_info.swa_url
                        },
                        slug: ele.slug,
                        type: ele.type
                    }
                ))
            )
        },
        getBestPaymentData: function (paymentData) {
            return JSON.stringify(paymentData.map(ele => (
                {
                    ID: ele.ID,
                    post_title: ele.post_title,
                    slug: ele.slug,
                    post_name: ele.post_name,
                    type: ele.type,
                    payment_category: ele.payment_category,
                    casino_count: {
                        url: ele.casino_count.url,
                        name: ele.casino_count.name,
                        overview: ele.casino_count.overview,
                        toplist_count: ele.casino_count.toplist_count
                    }
                }
            ))
            )
        },
        getAlternativeSoftwareProviderData: function (softwareData) {
            return JSON.stringify(softwareData
                .filter(ele => ele.soft_info.sw_overview)
                .map(ele => (
                    {
                        soft_info: {
                            sw_name: ele.soft_info.sw_name,
                            swa_url: ele.soft_info.swa_url,
                            sw_overview: ele.soft_info.sw_overview,
                            products_count: ele.soft_info.products_count
                        },
                        ID: ele.ID,
                        slug: ele.slug,
                        type: ele.type
                    }
                ))
            )
        },
        isCoreBlock: function (block) {
            const vue_blocks = Object.values(global.wpvue_script_data_params.data.vue_blocks)
            if (!(vue_blocks.indexOf(block) > -1))
                return true
            else
                return false
        },
        exclusiveCasinoData: function( casinoData ) {
            return JSON.stringify(casinoData.map(ele => (
                    {
                        product_name: ele.product_name,
                        go_link: ele.go_link,
                        slug: ele.slug,
                        rating: ele.rating,
                        bonus_match: ele.bonus_match,
                        review_link: ele.review_link,
                        exclusive_bonus_amount: ele.exclusive_bonus_amount,
                        exclusive_bonus_match: ele.exclusive_bonus_match,
                        bonus_amount: ele.bonus_amount,
                        bonus_currency: ele.bonus_currency,
                        freespin: ele.freespin,
                        freebie_name: ele.freebie_name,
                        show_freebie_currency: ele.show_freebie_currency,
                        cta_button_text: ele.cta_button_text,
                        bonus_tc: ele.bonus_tc,
                        terms: ele.terms,
                        term_link: ele.term_link,
                        asset_url: this.getAssetUrl( ele.product_assets, this.assetSizes.pro_asset_sizes.medium ),
                        bg_asset_url: this.getAssetUrl( ele.product_assets, this.assetSizes.pro_asset_sizes.background ),
                        banned_time_from: ele.banned_time_from,
                        banned_time_to: ele.banned_time_to,
                        show_bonus: ele.show_bonus,
                        hide_bonus: ele.hide_bonus,
                        hide_toplist: ele.hide_toplist
                    }
                ))
            )
        },
        getTopGamesData: function (gamesData) {
            return JSON.stringify(
                gamesData.map(ele => (
                    {
                        banner: ele.banner,
                        title: ele.title,
                        post_title: ele.post_title,
                        category: ele.category,
                        geo_provider_partners_data: ele.geo_provider_partners_data ? {
                            current: {
                                go_link: ele.geo_provider_partners_data.current.go_link,
                                product_name: ele.geo_provider_partners_data.current.product_name,
                                slug: ele.geo_provider_partners_data.current.slug
                            }
                        } : undefined,
                        game_tag: ele.game_tag ? {
                            color: ele.game_tag.color,
                            tag_name: ele.game_tag.tag_name
                        } : {},
                        meta: {
                            play_for_free_url: ele.meta.play_for_free_url
                        },
                        slug: ele.slug,
                        post_type: ele.post_type,
                        type: ele.type,
                        provider_name: ele.provider_name,
                        provider_link: ele.provider_link
                    }
                ))
            )
        },
        coreBlockData: function (blockData) {
            if(blockData.innerBlocks.length > 0) {
                return JSON.stringify(blockData.filtered_content)
            } else {
                return JSON.stringify(blockData.innerHTML)
            }
        },
        coreBlockAttrs: function (blockData) {
            if(Object.keys(blockData.attrs).length > 0) {
                return JSON.stringify(blockData.attrs)
            } else {
                return ''
            }
        },
        yoastFaqData: function (blockData) {
            if(blockData.attrs && blockData.attrs.questions.length > 0) {
                return JSON.stringify(blockData.attrs.questions.map(ele => ({id: ele.id, jsonAnswer: ele.jsonAnswer, jsonQuestion: ele.jsonQuestion})))
            } else {
                return '[]'
            }
        },
        gameGuideData: function (blockData) {
            return JSON.stringify(
                blockData.filtered_content.map(ele => (
                    {
                        name: ele.name,
                        thumbnail: ele.thumbnail,
                        hover_thumbnail: ele.hover_thumbnail,
                        description: ele.description,
                        goto: ele.goto
                    }
                ))
            )
        },
        getAssetUrl: function ( assetsArray, assetCatName) {
            let filteredAsset = assetsArray.filter(ele => ele.asset_category_name === assetCatName)
            if(filteredAsset.length > 0)
                return  filteredAsset[0].url
            else
                return this.$root.site_url + this.$root.asset_path + '/failure.png'
        },
        getHomeBannerToplist: function ( toplistData ) {
            if(!toplistData) return []
            return JSON.stringify(toplistData.map(ele => (
                    {
                        product_name: ele.product_name,
                        go_link: ele.go_link,
                        slug: ele.slug,
                        asset_url: this.getAssetUrl( ele.product_assets, this.assetSizes.pro_asset_sizes.medium),
                        goto: ele.goto,
                        tags: ele.tags,
                        review_link: ele.review_link,
                        bonus_match: ele.bonus_match,
                        bonus_amount: ele.bonus_amount,
                        exclusive_bonus_amount: ele.exclusive_bonus_amount,
                        exclusive_bonus_match: ele.exclusive_bonus_match,
                        bonus_currency: ele.bonus_currency,
                        freespin: ele.freespin,
                        freebie_name: ele.freebie_name,
                        show_freebie_currency: ele.show_freebie_currency,
                        cta_button_text: ele.cta_button_text,
                        bonus_tc: ele.bonus_tc,
                        terms: ele.terms,
                        banned_time_from: ele.banned_time_from,
                        banned_time_to: ele.banned_time_to,
                        show_bonus: ele.show_bonus,
                        hide_bonus: ele.hide_bonus,
                        hide_toplist: ele.hide_toplist
                    }
                ))
            )
        },
        getSimilarCasinoData: function ( toplistData ) {
            return JSON.stringify(
                toplistData.map(ele => (
                    {
                        product_name: ele.product_name,
                        go_link: ele.go_link,
                        slug: ele.slug,
                        bg_asset_url: this.getAssetUrl( ele.product_assets, this.assetSizes.pro_asset_sizes.background).includes('failure') ?
                            this.getAssetUrl( ele.product_assets, 'product_logo_background') : this.getAssetUrl( ele.product_assets, this.assetSizes.pro_asset_sizes.background),
                        img_asset_url: this.getAssetUrl( ele.product_assets, this.assetSizes.pro_asset_sizes.medium),
                        tags: ele.tags,
                        review_link: ele.review_link,
                        rating: ele.rating,
                        bonus_match: ele.bonus_match,
                        bonus_amount: ele.bonus_amount,
                        exclusive_bonus_amount: ele.exclusive_bonus_amount,
                        exclusive_bonus_match: ele.exclusive_bonus_match,
                        bonus_currency: ele.bonus_currency,
                        freespin: ele.freespin,
                        freebie_name: ele.freebie_name,
                        show_freebie_currency: ele.show_freebie_currency,
                        cta_button_text: ele.cta_button_text,
                        bonus_tc: ele.bonus_tc,
                        terms: ele.terms,
                        supported_payments: ele.supported_payments,
                        supported_payments_total: ele.supported_payments_total
                    }
                ))
            )
        }
    }
}
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/CustomComponent.vue